import ko from "knockout";
import * as systemInformationManager from "./systemInformationManager";
import bind from "bind-decorator";

export default class SystemInfoViewModel {
    isVisible = ko.observable(false);
    title = ko.observable();
    text = ko.observable();
    private guid: string;

    constructor() {
        systemInformationManager.addCloseSubscriber(this.closedInOtherTab);
    }

    @bind
    closedInOtherTab(guid: string) {
        if (this.guid === guid) {
            this.hide();
        }
    }

    showBanner(guid: string, title: string, text: string) {
        this.guid = guid;
        this.title(title);
        this.text(text);

        if (!this.isVisible()) {
            this.isVisible(true);
        }
    }

    private hide() {
        this.isVisible(false);
    }

    onClose() {
        this.hide();
        systemInformationManager.closeInAllTabs(this.guid);
    }
}
